export const initialValues = {
  lastname: null,
  itl_candidatecontact: null,
  itl_alternatecontact: "",
  // itl_bloodgroup: null,
  itl_presentaddress: null,
  itl_permanentaddress: null,
  itl_knowaboutussource: null,
};

export const qualificationsInitialValues = {
  itl_name: "",
  itl_institutename: "",
  itl_address: "",
  itl_year: "",
  itl_marksobtained: "",
  itl_classdivision: "",
};

export const experienceDetailsInitialValues = {
  itl_name: null,
  itl_periodfrom: null,
  itl_periodto: null,
  itl_designation: null,
  itl_reasonforleaving: null,
  itl_salarydrawn: null,
  itl_address: null,
};

export const familyDetailsInitialValues = {
  itl_name: "",
  itl_relation: null,
  itl_profession: "",
};

export const referencesInitialValues = {
  itl_relationship: "",
  itl_referenceid: "",
  itl_reference: null,
  itl_contact: "",
  itl_name: "",
  itl_address: "",
  itl_email: "",
};

export const referencesInitialArray = [
  {
    itl_relationship: "",
    itl_referenceid: "",
    itl_reference: 1,
    itl_contact: "",
    itl_name: "",
    itl_address: "",
    itl_email: "",
  },
  {
    itl_relationship: "",
    itl_referenceid: "",
    itl_reference: 2,
    itl_contact: "",
    itl_name: "",
    itl_address: "",
    itl_email: "",
  },
];

export const knowAboutUsRadios = [
  {
    label: "Job Posting",
    value: 1,
  },
  {
    label: "Call from HR",
    value: 2,
  },
  {
    label: "Employee Referral",
    value: 3,
  },
  {
    label: "Walk In",
    value: 4,
  },
  {
    label: "Consultant",
    value: 5,
  },
  {
    label: "Others",
    value: 6,
  },
];
